export function initialize_animations() {
  // TODO: Replace with CSS animations
  $('body').on('click', '.fade-on-click', function(){
    var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
    var clickedDiv = $(this).closest('div.grid-cell');
    clickedDiv.addClass('animated fadeOut').slideUp(500).one(animationEnd, function() {
      clickedDiv.remove();
    });
  });
}